import { api } from "@/lib/api";

// Ensure cookies are sent on all admin API calls
api.defaults.withCredentials = true;

export async function adminLogin(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
}
export async function adminLogout() {
  await api.post("/auth/logout");
}
export async function adminMe() {
  const { data } = await api.get("/auth/me");
  return data;
}
export async function adminStats() {
  const { data } = await api.get("/admin/stats");
  return data;
}
export async function adminQuestions(limit = 100) {
  const { data } = await api.get("/admin/questions", { params: { limit } });
  return data;
}
export async function adminTopQuestions(limit = 20) {
  const { data } = await api.get("/admin/top-questions", { params: { limit } });
  return data;
}
export async function adminDaily(days = 14) {
  const { data } = await api.get("/admin/daily", { params: { days } });
  return data;
}
